module.exports = __webpack_public_path__ + "img/igaracu.3ed2c08e.png";